<template>
	<div class="content">
		<div class="row animated fadeIn">
			<div class="col-12">
				<Alert :type="alertType" :message="alertMessage" v-if="alertShow === true" />
				<div class="card" v-if="asyncDone === false">
					<!-- Show the loader when async operation is going on -->
					<div class="loader"></div>
				</div>
			</div>
			<div class="col-12" v-if="asyncDone">
				<div class="card">
					<div class="card-header mt-3">
						<h4 class="card-title d-inline-block ml-4">Ticket Archive</h4>
						<router-link :to="{name: 'openTicket'}" tag="button" type="button" class="btn btn-primary btn-round d-inline-block float-right">
							<i class="fa fa-plus"></i> Open New Support Ticket
						</router-link>
					</div>
					<div class="card-body pl-5 pr-5">
						<div class="table-responsive">
							<table class="table">
								<thead class="text-primary">
									<th class="text-center">Ticket #</th>
									<th>Subject</th>
									<th>Last Reply Date</th>
									<th class="text-center">Current Status</th>
									<th class="text-right">Actions</th>
								</thead>
								<tbody>
									<tr v-for="ticket in tickets" :key="ticket.ticket_number">
										<td class="text-center">{{ ticket.ticket_number }}</td>
										<td>{{ getTicketSubject(ticket.tsubject) }}</td>
										<td>{{ ticket.lastreply_date }}</td>
										<td class="text-center"><span class="badge badge-pill" :class="getTicketStatusClass(ticket.status)">{{ ticket.status }}</span></td>
										<td class="text-right">
											<router-link tag="a" class="btn btn-primary btn-sm" :to="{ name: 'viewTicket', params: { id: encryptIndex( ticket.ticket_number.toString() ) } }">
												View Ticket
											</router-link>
										</td>
									</tr>
								</tbody>
							</table>
							<div class="center">
								<ul class="pagination pagination-primary">
									<li class="page-item" :class="{ 'active' : selectedPage === index }" v-for="(page, index) in pages" :key="index">
										<button class="page-link" type="button" @click.prevent="fetchTickets(index)">{{ page }}</button>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
				<router-link :to="{name: 'openTicket'}" tag="button" type="button" class="btn btn-primary btn-lg w-100">
					<i class="fa fa-plus"></i> Open New Support Ticket
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
import AES from 'crypto-js/aes'
import { functions } from "@/firebase/init"

export default {
  name: "ticketArchivePage",
  components: {
	Alert: () =>
		import(/* webpackChunkName: "alert" */ "../../../../components/Alerts.vue")
	},
	data() {
		return {
			tickets: [],
			pageCount: null,
			selectedPage: 0
		}
	},
  computed: {
		clientID() {
			return this.$store.getters.getCustomerID
		},
	asyncDone() {
		return this.$store.getters["async/state"];
	},
	alertType() {
		return this.$store.getters["alert/type"];
	},
	alertMessage() {
	return this.$store.getters["alert/message"];
	},
	alertShow() {
	return this.$store.getters["alert/show"];
		},
		aesSecret() {
	return this.$store.getters["crypto/aesSecret"];
	},
		pages() {
			if(this.pageCount !== null) {
				const pages = [];
				for(let i = 1; i<= this.pageCount; i++) {
					pages.push(i)
				}
				return pages
			}
		}
	},
	methods: {
		encryptIndex(index) {
	return AES.encrypt(index, this.aesSecret).toString()
	},
		getTicketSubject(tsubject) {
			const strSplit = tsubject.split('-')
			strSplit.splice(0, 1)
			const sub = strSplit.join('-')
			return sub.trim()
		},
		getTicketStatusClass(status) {
			return {
				"badge-success": status === "Answered",
				"badge-warning": status === "In-Progress" || status === "Pending",
				"badge-info": (status === "Open" || status === "Sales Followup"),
				"badge-primary": (status === "Client-Reply" || status === "Waiting on Billing"),
				"badge-default": status === "Closed",
				"badge-danger": status === 'Abuse'
			}
		},
		fetchTickets(pageNo) {
			this.selectedPage = pageNo

			this.$store.dispatch("async/stateUpdate", { state: false })

			const fetchSupportTicketsByPage = functions.httpsCallable("fetchSupportTicketsByPage")
			fetchSupportTicketsByPage({
				clientID: this.clientID,
				page: pageNo
			})
			.then(response => {
				this.$store.dispatch("async/stateUpdate", { state: true })

				this.pageCount = response.data.pageCount

				this.tickets = [
					...response.data.supportTickets
				]
			})
			.catch(err => {
				this.$store.dispatch("async/stateUpdate", { state: true })

				this.$store.dispatch("alert/update", {
					type: "error",
					message: err.message,
					show: true
				})

				this.addLog({
					message: "Error: Archive Ticket, Message:" + err.message,
					level:  "danger"
				})

				setTimeout(() => {
					this.$store.dispatch("alert/showUpdate", { show: false })
				}, 5000)
			})
		}
	},
	created() {
		this.fetchTickets(0)
	}
};
</script>
